<script setup lang="ts">
const { isMobile } = useBreakpoint()
const { isNewHeader } = useHeaderV2()

const imageCover = computed(() =>
  isMobile.value
    ? 'https://collectionist.s3.eu-west-1.amazonaws.com/production/assets/homepage/2025/cover-summer-2025-mobile-2.webp'
    : 'https://collectionist.s3.eu-west-1.amazonaws.com/production/assets/homepage/2025/cover-summer-2025-desktop-2.webp',
)
const s3Url = computed(() =>
  isMobile.value
    ? 'https://collectionist.s3.eu-west-1.amazonaws.com/production/assets/homepage/2025/video-summer-2025-mobile-3.mp4'
    : 'https://collectionist.s3.eu-west-1.amazonaws.com/production/assets/homepage/2025/video-summer-2025-desktop-3.mp4',
)

const containerSearch = ref<HTMLDivElement | null>(null)
const fixed = ref(false)
const SIZE_TOP_FIXED = 24

const onScroll = () => {
  const position = containerSearch.value?.getBoundingClientRect()?.top || 0

  fixed.value = position - SIZE_TOP_FIXED < 0
}

onMounted(() => {
  if (isNewHeader.value) {
    document.addEventListener('scroll', onScroll)
  }
})

onUnmounted(() => {
  if (isNewHeader.value) {
    document.removeEventListener('scroll', onScroll)
  }
})
</script>

<template>
  <BaseVideoBg
    class="mb-[200px] flex h-[458px] items-center bg-gray-700/30 text-center md:mb-0"
    :img="imageCover"
    :source="s3Url"
  >
    <div class="home-bg-video__overlay" />
    <BaseContainer class="pt-[510px] md:pt-0">
      <BaseRow class="justify-center">
        <BaseCol md="20" lg="14">
          <h2
            class="mb-2 text-5xl leading-9 text-white md:text-[28px] md:leading-7"
            data-cy="homepage-title"
          >
            {{ $t('home.headline') }}
          </h2>
          <p
            class="mb-0 hidden text-md leading-5 text-white md:block md:text-base"
            data-cy="homepage-subtitle"
          >
            {{ $t('home.headline_subtitle') }}
          </p>

          <template v-if="isMobile">
            <HomeWonderingWhereToGo />
            <SearchInputV2MobileContainer />
          </template>

          <template v-else>
            <div
              ref="containerSearch"
              class="my-4 flex h-[52px] justify-center"
            >
              <SearchInputV2Container
                :class="{ 'fixed top-4 z-modal': fixed }"
                large
                next-flow
              />
            </div>
            <HomeWonderingWhereToGo />
          </template>
        </BaseCol>
      </BaseRow>
    </BaseContainer>
  </BaseVideoBg>
</template>
